interface Props {
  count: number;
  factorCount: number;
  updatedAt: string;
  onCloseMobile?: () => void;
}

export function StatsGrid({ count, factorCount, updatedAt, onCloseMobile }: Props) {
  return (
    <div className="px-5 pt-3 pb-3 border-b border-[#1e293b]">
      <div className="grid grid-cols-3 gap-2">
        <div className="rounded-md bg-[#111827]/60 border border-[#1e293b] px-2 py-1.5">
          <div className="text-[7px] text-[#64748b] uppercase tracking-widest">Universe</div>
          <div className="text-white text-lg font-bold tabular-nums leading-none mt-0.5" style={{ fontFamily: 'var(--font-mono)' }}>
            {count}
          </div>
          <div className="text-[7px] text-[#94a3b8] tracking-wide mt-0.5">US · CA</div>
        </div>
        <div className="rounded-md bg-[#111827]/60 border border-[#1e293b] px-2 py-1.5">
          <div className="text-[7px] text-[#64748b] uppercase tracking-widest">Factors</div>
          <div className="text-lg font-bold tabular-nums leading-none mt-0.5" style={{ color: '#4ade80', fontFamily: 'var(--font-mono)' }}>
            {factorCount}
          </div>
          <div className="text-[7px] text-[#94a3b8] tracking-wide mt-0.5">Q · V</div>
        </div>
        <div className="rounded-md bg-[#111827]/60 border border-[#1e293b] px-2 py-1.5">
          <div className="text-[7px] text-[#64748b] uppercase tracking-widest">Refresh</div>
          <div className="text-[11px] tabular-nums leading-tight mt-0.5" style={{ color: '#f59e0b', fontFamily: 'var(--font-mono)' }}>
            {updatedAt ? new Date(updatedAt).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' }) : '--'}
          </div>
          <div className="text-[7px] text-[#94a3b8] tracking-wide mt-0.5">Next 6:00</div>
        </div>
      </div>
      {onCloseMobile && (
        <button onClick={onCloseMobile} className="md:hidden absolute top-2 right-2 p-1 text-white/60 hover:text-white" aria-label="Close menu">
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
            <line x1="4" y1="4" x2="14" y2="14" /><line x1="14" y1="4" x2="4" y2="14" />
          </svg>
        </button>
      )}
    </div>
  );
}
